import { ButtonCloseStyle } from "./style"

export type Props = {
    onClick: () => void;
}
export const ButtonClose: React.FC<Props> = ({ onClick }) => {
    return (
        <ButtonCloseStyle onClick={onClick} />
    )
}